import React from 'react';
import {
  Button,
  Box,
  Typography
} from '@mui/material';
import { Facebook as FacebookIcon } from '@mui/icons-material';

const FacebookSignInButton = ({ onSuccess, onError, disabled = false, variant = 'contained', size = 'large' }) => {
  const handleFacebookLogin = () => {
    console.log('Starting Facebook login...');
    
    // Initialize Facebook SDK if not already done
    if (!window.FB) {
      console.error('Facebook SDK not loaded');
      if (onError) {
        onError(new Error('Facebook SDK not available'));
      }
      return;
    }

    // Request login with required permissions
    window.FB.login((response) => {
      console.log('Facebook login response:', response);
      
      if (response.authResponse) {
        // Success - we have an access token
        const accessToken = response.authResponse.accessToken;
        console.log('Facebook login successful, access token:', accessToken);
        
        if (onSuccess) {
          onSuccess({ access_token: accessToken });
        }
      } else {
        // User cancelled or login failed
        console.log('Facebook login cancelled or failed');
        if (onError) {
          onError(new Error('Facebook login was cancelled or failed'));
        }
      }
    }, {
      scope: 'email,public_profile',
      return_scopes: true
    });
  };

  return (
    <Button
      variant={variant}
      size={size}
      onClick={handleFacebookLogin}
      disabled={disabled}
      sx={{
        bgcolor: variant === 'contained' ? '#1877f2' : 'transparent',
        color: variant === 'contained' ? 'white' : '#1877f2',
        border: variant === 'outlined' ? '1px solid #1877f2' : 'none',
        '&:hover': {
          bgcolor: variant === 'contained' ? '#166fe5' : 'rgba(24, 119, 242, 0.04)',
        },
        '&:disabled': {
          bgcolor: variant === 'contained' ? 'rgba(24, 119, 242, 0.38)' : 'transparent',
          color: variant === 'contained' ? 'rgba(255, 255, 255, 0.38)' : 'rgba(24, 119, 242, 0.38)',
        }
      }}
      fullWidth
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <FacebookIcon />
        <Typography variant="button">
          Continue with Facebook
        </Typography>
      </Box>
    </Button>
  );
};

export default FacebookSignInButton;